module.exports = {
	GameInput: require("./GameInput").default,
	GameInputControl: require("./GameInputControl").default,
	GameInputDevice: require("./GameInputDevice").default,
	Keyboard: require("./Keyboard").default,
	KeyLocation: require("./KeyLocation").default,
	Mouse: require("./Mouse").default,
	MouseCursor: require("./MouseCursor").default,
	Multitouch: require("./Multitouch").default,
	MultitouchInputMode: require("./MultitouchInputMode").default,
}